module.exports = __webpack_public_path__ + "img/531.1ac5227e.gif";